import { selectDate as selectDateAction, selectHour } from '@r1-frontend/service-engineer-visit/actions/simple';
import { TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';
import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const selectDate = (date: string) => (dispatch: TContextDispatch, getState: () => TInitialState) => {
    const {
        _incomingData,
        slots,
    } = getState();

    if (!_incomingData) {
        throw new Error('Incoming data is not set');
    }

    dispatch(selectDateAction(date));

    for (const hourKey in slots[date].hours) {
        if (slots[date].hours[hourKey].active) {
            dispatch(selectHour(String(slots[date].hours[hourKey].from)));
            break;
        }
    }
};

export default selectDate;
